// extracted by mini-css-extract-plugin
export var hidden = "_ug-0";